export class mdlProposalAddRes_Upgrade{
    public ProposalNo: string;
    public StatusCode: string;
    public ErrorMsg: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlProposalAddRes_Upgrade.ts